export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schauspieler01-mobile-de.9bf5e699.png";